import { createContext } from 'react';
import { DEFAULT_FORM_FIELD_VARIANT } from './formField.config';
import type { FormFieldContextValue } from './formField.types';

export const FormFieldContext = createContext<FormFieldContextValue>({
  variant: DEFAULT_FORM_FIELD_VARIANT,
  size: 'large',
});
